import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { get } from '../../services/http'
import { Branding } from '../../interfaces';
import { initialBranding } from '../intialState/branding';
import { SliceStatus } from '../../interfaces/Redux';

export interface AppState {
  branding: Branding
  status: SliceStatus
  error?: string | undefined
}

const initialState: AppState = {
  branding: initialBranding,
  status: SliceStatus.initial,
  error: '',
}

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
      setAppBranding: (state, action) => {
        state.branding = action.payload;
      },
      resetBranding: (state) => {
        state = initialState;
      }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchBranding.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchBranding.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          // Add any fetched posts to the array
          state.branding = {
            ...action.payload,
            bgColor: state.branding.bgColor
          };
          state.error = undefined;
        }
        
      })
      .addCase(fetchBranding.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.branding = initialBranding;
        state.error = action.error.message
      })
  }
})

let lastFetchParams = ''
let lastResponseData = {};

export const fetchBranding = createAsyncThunk('branding/fetchBranding', async (shortName: string) => {

  let brandingData: any;

  if(shortName != lastFetchParams ) {
    const { data } = await  get(`api/organization/${shortName}/branding`)
      .catch((response) => {
        throw new Error(response.message);
      });

    lastResponseData = brandingData = data;
    lastFetchParams = shortName
  }
    
  else {
    brandingData = lastResponseData;
  }
    
  return {
        orgBgColor: brandingData.color ?? '',
        bgColor: brandingData.color ?? '',
        bgLogo: '',
        buttonColor: brandingData.buttonColor ?? '',
        favIcon: brandingData.iconUrl ?? '',
        logo: brandingData.logoUrl ?? '',
        orgName: brandingData.organisationName ?? '',
        loginScreenBgImage: brandingData.loginScreenBgImageUrl ?? '',
        shortname: shortName
    }
});

export const { setAppBranding, resetBranding } = brandingSlice.actions 

export default brandingSlice.reducer



